import { CONFIG } from '@/config/Config';
import Cookies from 'js-cookie';

export function addSessionId(baseHeaders: Record<string, string> = {}): Record<string, string> {
  const headers = { ...baseHeaders };

  const sessionId = Cookies.get(CONFIG.AUTH.SSID);
  if (sessionId) {
    headers['stilingue-session-id'] = sessionId;
  }

  return headers;
}
